module.exports = __webpack_public_path__ + "static/media/music.1bbe935e.jpg";